// extracted by mini-css-extract-plugin
export default {"size":"AdminCardList_size__thsZb","wrapperList":"AdminCardList_wrapperList__bw44b"};